export const CHANGE_CURRENT_PAGE = 'productSizes/CHANGE_CURRENT_PAGE'
export const CHANGE_PAGE_SIZE = 'productSizes/CHANGE_PAGE_SIZE'
export const CREATE_PRODUCT_SIZE = 'productSizes/CREATE_PRODUCT_SIZE'
export const FETCH_PRODUCT_SIZE = 'producrSizes/FETCH_PRODUCT_SIZE'
export const FETCH_PRODUCT_SIZES_LIST = 'productSizes/FETCH_PRODUCT_SIZES_LIST'
export const REMOVE_PRODUCT_SIZE = 'productSizes/REMOVE_PRODUCT_SIZE'
export const UPDATE_PRODUCT_SIZE = 'productSizes/UPDATE_PRODUCT_SIZE'
export const FETCH_PRODUCT_SIZES_FOR_OPTIONS = 'productSizes/FETCH_PRODUCT_SIZES_FOR_OPTIONS'
